import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import QuotationMarksIcon from "./icon-quotation-marks.svg";

export const StyledQuoteIcon = styled(QuotationMarksIcon)`
  flex-shrink: 0;

  inline-size: 121px;
  block-size: 25px;
  margin-block-end: 20px;
`;

export const StyledFigure = styled.figure`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  max-inline-size: 360px;
  margin-block: var(--mobile-widget-gap, 16px);
  margin-inline: auto;
  padding-block: 20px;
  padding-inline: 0;

  text-align: center;

  ${theme.breakpoints.up("desktop")} {
    margin-block: var(--desktop-widget-gap, 18px);
  }
`;

export const StyledBlockquote = styled.blockquote`
  margin: 0;

  color: #000000;
  font-weight: 500;
  font-size: 20px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 130%;
  overflow-wrap: break-word;

  ${theme.breakpoints.up("tablet")} {
    font-size: 24px;
  }
`;

export const StyledFigcaption = styled.figcaption`
  margin-block-start: 8px;

  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  overflow-wrap: break-word;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
  }
`;
